var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtmlIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.693,
    height: 56.693,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("polygon", {
    fill: "#38b2ac",
    id: "svg_2",
    points: "16.356,9.799 18.382,9.799 18.382,12.018 20.598,12.018 20.598,5.391 18.382,5.391    18.382,7.581 16.356,7.581 16.356,5.391 14.141,5.391 14.141,12.018 16.356,12.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#38b2ac",
    id: "svg_3",
    points: "23.51,12.018 25.725,12.018 25.725,7.59 27.674,7.59 27.674,5.391 21.561,5.391    21.561,7.59 23.51,7.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#38b2ac",
    id: "svg_4",
    points: "30.812,8.735 32.338,11.09 32.375,11.09 33.898,8.735 33.898,12.018 36.105,12.018    36.105,5.391 33.795,5.391 32.375,7.723 30.955,5.391 28.646,5.391 28.646,12.018 30.812,12.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#38b2ac",
    id: "svg_5",
    points: "42.537,9.829 39.422,9.829 39.422,5.391 37.207,5.391 37.207,12.018 42.537,12.018     "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38b2ac",
    id: "svg_6",
    d: "m10.949,14.926l3.168,35.532l14.221,3.947l14.232,-3.945l3.174,-35.534l-34.795,0zm27.922,11.62l-10.525,0l-6.152,0l0.398,4.463l5.754,0l10.129,0l-1.195,13.383l-8.934,2.475l-0.006,0.002l-8.928,-2.477l-0.623,-7l4.374,0l0.324,3.631l4.854,1.312l0.006,-0.002l0,0l4.859,-1.312l0.506,-5.652l-5.365,0l0,0l-9.739,0l-1.177,-13.179l10.915,0l10.914,0l-0.389,4.356z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/htmlIcon.bc973090f25aa1879ea54682c5342ec5.svg";
export { ForwardRef as ReactComponent };